import { PaymentRequest } from "@omni/types/components/payment/paymentRequest.model";
import { ThunkDispatch } from "redux-thunk";

import CreateApiModule from "@/redux/create-api-module";
import { $PaymentModuleName } from "@/redux/modules/api/data/checkout/payment/payment.types";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { translateKey } from "@/redux/modules/value/translations/translations.helpers";
import { getTranslations } from "@/redux/modules/value/translations/translations.selector";
import {
    IState,
    TApiAction,
    TExtendedApiAction,
    TExtraThunkArgs
} from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import PaymentReducer from "./payment.reducer";

const { actions, constants } = CreateApiModule(
    $PaymentModuleName,
    ({ url }) => url,
    {
        mergeParams: false,
        reducer: PaymentReducer
    }
);

export const setLoading = (
    dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>
) =>
    dispatch({
        type: constants.PENDING,
        payload: {},
        actionOptions: {}
    });

export const setError = (
    dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>,
    error: unknown
) =>
    dispatch({
        type: constants.FAILURE,
        payload: error,
        actionOptions: {}
    });

export const createPayment =
    (paymentRequest: PaymentRequest) =>
    async (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>,
        getState: () => IState
    ) => {
        const result = await dispatch(
            actions.load<TExtendedApiAction<PaymentResponse>>(
                {
                    path: {
                        url: `/cartservice/${Config.general.basestore}/checkout/place-order`
                    },
                    data: paymentRequest
                },
                "POST",
                true
            )
        );

        if (result.type !== constants.SUCCESS) {
            const translations = getTranslations(getState());
            broadcastMessage({
                id: "place-order-failure",
                text: translateKey(translations, "checkout.placeOrder.failure"),
                status: "danger",
                dismissible: true,
                activeScroll: true
            });
        }

        return result;
    };

export const load = actions.load;
export const clear = actions.clear;
export const refetch = actions.refetch;
export const APIStatus = constants;
